import React from "react";

export default function WizardNavButtons({
    currentStep,
    totalSteps,
    saving = false,
    onBack,
    onNext,
    submitLabel,
    savingLabel,
}) {
    const isFirstStep = currentStep === 0;
    const isLastStep = currentStep >= totalSteps - 1;

    return (
        <div className="new-spot-nav-buttons" style={{ gridColumn: "1 / -1" }}>
            {!isFirstStep ? (
                <button
                    type="button"
                    className="ghost-btn"
                    onClick={(e) => {
                        e.preventDefault();
                        onBack();
                    }}
                >
                    Назад
                </button>
            ) : (
                <span />
            )}
            {!isLastStep ? (
                <button
                    key={`next-${currentStep}`}
                    type="button"
                    className="toolbar-btn"
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={(e) => {
                        e.preventDefault();
                        onNext();
                    }}
                >
                    Далее
                </button>
            ) : (
                <button
                    key="submit-last-step"
                    type="submit"
                    className="toolbar-btn"
                    disabled={saving}
                >
                    {saving ? savingLabel : submitLabel}
                </button>
            )}
        </div>
    );
}
